import { BaseSdk } from '../base.sdk';

export class RootSdk extends BaseSdk {
    async getOpenGraphMetaData(url: string) {
        return this.post<any>({ path: `open-graph`, payload: { url: url } });
    }
}
